<ion-app>
  <app-header *ngIf="showHeader"></app-header>

  <div class="translate" id="open-language-modal">
    <img src="../assets/images/language.svg" alt="">
  </div>

  <ion-content>
    <ion-split-pane contentId="main-content" [ngClass]="{ 'space-for-header': showHeader }">
      <ion-router-outlet id="main-content"></ion-router-outlet>
    </ion-split-pane>
  </ion-content>

  <app-footer *ngIf="showHeader"></app-footer>

  <app-overlay-loading></app-overlay-loading>
</ion-app>


<ion-modal #modal trigger="open-language-modal" [initialBreakpoint]="0.75" [breakpoints]="[0, 0.25, 0.5, 0.75]">
  <ng-template>
    <ion-content class="modal-content">
      <!-- Header with Apply Button -->
      <div class="modal-header">
        <h2>Select a Language</h2>
        <div style="display: flex;align-items: center;justify-content: flex-end;">
          <ion-button fill="solid" color="primary" size="small" (click)="applyLanguage()">Apply</ion-button>
        <ion-button fill="solid" color="light" size="small" (click)="resetLanguage()">Reset</ion-button>
        </div>
      </div>

      <!-- Search Bar -->
      <ion-searchbar 
        class="custom-searchbar" 
        placeholder="Search language..." 
        [(ngModel)]="searchText" 
        (ionInput)="filterLanguages()">
      </ion-searchbar>

      <!-- Language List -->
      <ion-list class="language-list">
        <ion-radio-group [(ngModel)]="selectedLanguage">
          <ion-item class="language-item" *ngFor="let lan of filteredLanguages">
            <ion-radio color="primary" [value]="lan.lan_key"></ion-radio>
            <ion-label>{{ lan.nativeName }}</ion-label>
          </ion-item>
        </ion-radio-group>
      </ion-list>
    </ion-content>
  </ng-template>
</ion-modal>


